import React from 'react';

interface IProps {
  title?: string;
  className?:string;
  childElement?: React.ReactNode;
  key?: string;
  handleOnClick?: () => void;
  handleOnMouseIn?: () => void;
  handleOnMouseOut?: () => void;
  id: string;
}

const CopyButton = ({
  title,
  className,
  childElement,
  key,
  handleOnClick,
  handleOnMouseIn,
  handleOnMouseOut,
  id,
}: IProps) => (
  <button
    id={id}
    type='button'
    key={key}
    className={className}
    onClick={handleOnClick}
    onMouseEnter={handleOnMouseIn}
    onMouseLeave={handleOnMouseOut}
  >
    {childElement && childElement}
    <span className='h-[1.5rem]'>{title ?? ''}</span>
  </button>
);

export default CopyButton;
